import React from "react";

export default function SpinnerTwo() {
  return (
    <div className="flex items-center justify-center gap-4 sm:justify-normal">
      <div className="animate-spin">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3755_26222)">
            <path
              opacity="0.33"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.6065 0.345176L12.1758 1.95287C11.9416 1.88993 11.7051 1.83929 11.4631 1.79612C11.2211 1.75296 10.9817 1.71873 10.7401 1.6968L10.8919 0.0393588C11.1793 0.065229 11.4686 0.104137 11.7557 0.15535C12.0429 0.206563 12.3278 0.270083 12.6065 0.345176Z"
              fill="#465FFF"
            />
            <path
              opacity="0.38"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.0174 1.34668L14.1804 2.78878C13.7667 2.54568 13.3292 2.34069 12.868 2.17378L13.4393 0.608099C13.9919 0.808241 14.5186 1.05878 15.0174 1.34668Z"
              fill="#465FFF"
            />
            <path
              opacity="0.42"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.0872 2.94301L15.9045 4.11607C15.5638 3.77174 15.192 3.45993 14.7937 3.17728L15.7559 1.81676C16.233 2.15579 16.6781 2.53145 17.0872 2.94301Z"
              fill="#465FFF"
            />
            <path
              opacity="0.5"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.6688 5.01549L17.2256 5.84581C16.9831 5.42586 16.7074 5.02541 16.3972 4.65265L17.6753 3.58549C18.0484 4.03294 18.382 4.51147 18.6688 5.01549Z"
              fill="#465FFF"
            />
            <path
              opacity="0.55"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.6684 7.42856L18.0557 7.85621C17.9323 7.38556 17.7642 6.92809 17.5622 6.49423L19.0718 5.79002C19.3166 6.31617 19.5152 6.86372 19.6684 7.42856Z"
              fill="#465FFF"
            />
            <path
              opacity="0.6"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.0023 10.0191L18.3356 10.0139C18.3384 9.52342 18.2932 9.04132 18.213 8.56568L19.8548 8.2829C19.9532 8.84644 20.0055 9.43137 20.0023 10.0191Z"
              fill="#465FFF"
            />
            <path
              opacity="0.65"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.8449 11.7559C19.7937 12.043 19.7302 12.328 19.6551 12.6066L18.044 12.1711C18.1062 11.941 18.161 11.7053 18.2041 11.4633C18.2473 11.2212 18.2782 10.977 18.2993 10.7396L19.9609 10.892C19.9358 11.1753 19.8968 11.4647 19.8449 11.7559Z"
              fill="#465FFF"
            />
            <path
              opacity="0.7"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.3919 13.436C19.191 13.9927 18.9405 14.5194 18.6526 15.0182L17.2105 14.1812C17.4495 13.7667 17.6593 13.3259 17.8262 12.8647L19.3919 13.436Z"
              fill="#465FFF"
            />
            <path
              opacity="0.75"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.1846 15.7511C17.8448 16.2323 17.4691 16.6774 17.0583 17.0824L15.8845 15.9038C16.2248 15.5624 16.5407 15.1913 16.8192 14.7923L18.1846 15.7511Z"
              fill="#465FFF"
            />
            <path
              opacity="0.8"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.4122 17.67C15.9688 18.0438 15.4903 18.3774 14.9855 18.6683L14.1552 17.2251C14.5752 16.9826 14.9723 16.7021 15.345 16.3919L16.4122 17.67Z"
              fill="#465FFF"
            />
            <path
              opacity="0.95"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.2118 19.0721C13.6856 19.3168 13.1381 19.5154 12.574 19.6645L12.1415 18.0552C12.6129 17.9277 13.0696 17.7637 13.5083 17.5584L14.2118 19.0721Z"
              fill="#465FFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.7166 19.8506C11.1483 19.9524 10.5682 20.0013 9.97971 20.0021L9.98494 18.3355C10.4761 18.3342 10.9575 18.2931 11.429 18.2121L11.7166 19.8506Z"
              fill="#465FFF"
            />
            <path
              opacity="0.05"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.10628 19.9606C8.81886 19.9347 8.52953 19.8958 8.2424 19.8446C7.95526 19.7934 7.67032 19.7298 7.39168 19.6547L7.82306 18.0429C8.05731 18.1059 8.29303 18.1606 8.53504 18.2038C8.77706 18.247 9.01717 18.2771 9.25874 18.299L9.10628 19.9606Z"
              fill="#465FFF"
            />
            <path
              opacity="0.07"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.13218 17.8261L6.56089 19.3917C6.00901 19.1875 5.48159 18.9411 4.98345 18.6491L5.81978 17.2111C6.23425 17.4501 6.67172 17.6551 7.13218 17.8261Z"
              fill="#465FFF"
            />
            <path
              opacity="0.09"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.20654 16.8185L4.24436 18.179C3.76658 17.8441 3.32146 17.4684 2.91237 17.0569L4.09579 15.8797C4.43645 16.224 4.80831 16.5358 5.20654 16.8185Z"
              fill="#465FFF"
            />
            <path
              opacity="0.11"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.60309 15.3433L2.32501 16.4105C1.95195 15.963 1.61829 15.4845 1.3315 14.9805L2.77472 14.1501C3.01725 14.5701 3.29289 14.9705 3.60309 15.3433Z"
              fill="#465FFF"
            />
            <path
              opacity="0.13"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.43882 13.5057L0.929947 14.2058C0.684465 13.6837 0.485856 13.1362 0.333388 12.5672L1.94603 12.1396C2.06948 12.6103 2.2376 13.0677 2.43882 13.5057Z"
              fill="#465FFF"
            />
            <path
              opacity="0.15"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.78956 11.4303L0.147002 11.7172C0.0493218 11.1495 -0.00368106 10.5687 0.000299417 9.97688L1.66694 9.98211C1.66411 10.4726 1.7086 10.9588 1.78956 11.4303Z"
              fill="#465FFF"
            />
            <path
              opacity="0.17"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.79646 8.53667C1.75329 8.77868 1.72316 9.01879 1.70197 9.25626L0.0396938 9.10791C0.0655641 8.82049 0.104472 8.53116 0.155685 8.24402C0.206899 7.95689 0.271149 7.66784 0.345511 7.3933L1.95731 7.82469C1.89509 8.05484 1.83962 8.29466 1.79646 8.53667Z"
              fill="#465FFF"
            />
            <path
              opacity="0.19"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.78818 5.8148C2.54846 6.23338 2.33936 6.67011 2.17245 7.1313L0.606769 6.56001C0.806911 6.0074 1.05818 5.47661 1.34535 4.98185L2.78818 5.8148Z"
              fill="#465FFF"
            />
            <path
              opacity="0.21"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.1165 4.09609C3.777 4.43338 3.46109 4.80451 3.18254 5.20347L1.81718 4.24467C2.15622 3.76762 2.53188 3.3225 2.94344 2.91341L4.1165 4.09609Z"
              fill="#465FFF"
            />
            <path
              opacity="0.25"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.84508 2.77086C5.42513 3.01339 5.02805 3.29386 4.65529 3.60406L3.58813 2.32599C4.03148 1.9522 4.51 1.61853 5.01476 1.32764L5.84508 2.77086Z"
              fill="#465FFF"
            />
            <path
              opacity="0.28"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.86269 1.94102C7.39131 2.06856 6.93458 2.23258 6.49588 2.4379L5.79167 0.9283C6.31782 0.683551 6.86537 0.484941 7.43021 0.331741L7.86269 1.94102Z"
              fill="#465FFF"
            />
            <path
              opacity="0.3"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.0152 1.66437C9.52478 1.66154 9.04342 1.70265 8.57114 1.78772L8.28427 0.145157C8.8519 0.0474769 9.43273 -0.00552584 10.0205 -0.00227699L10.0152 1.66437Z"
              fill="#465FFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_3755_26222">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div className="animate-spin">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3755_26248)">
            <path
              opacity="0.33"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.649 0.483247L17.0461 2.73402C16.7182 2.6459 16.3871 2.575 16.0483 2.51457C15.7095 2.45414 15.3744 2.40622 15.0362 2.37552L15.2486 0.0551023C15.651 0.0913206 16.056 0.145791 16.458 0.21749C16.86 0.289189 17.2589 0.378116 17.649 0.483247Z"
              fill="#465FFF"
            />
            <path
              opacity="0.38"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.0236 1.88545L19.8518 3.90438C19.2725 3.56406 18.6601 3.27706 18.0144 3.04339L18.8142 0.851436C19.5879 1.13163 20.3252 1.48239 21.0236 1.88545Z"
              fill="#465FFF"
            />
            <path
              opacity="0.42"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.9221 4.12051L22.2663 5.76279C21.7894 5.28072 21.2688 4.8442 20.7112 4.44849L22.0583 2.54375C22.7262 3.0184 23.3493 3.54432 23.9221 4.12051Z"
              fill="#465FFF"
            />
            <path
              opacity="0.5"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26.1363 7.02158L24.1158 8.18403C23.7763 7.59611 23.3904 7.03548 22.9561 6.51362L24.7454 5.01958C25.2677 5.64602 25.7348 6.31595 26.1363 7.02158Z"
              fill="#465FFF"
            />
            <path
              opacity="0.55"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M27.5373 10.3999L25.2796 10.9986C25.1067 10.3397 24.8714 9.69923 24.5886 9.09182L26.7021 8.10593C27.0447 8.84254 27.3228 9.60911 27.5373 10.3999Z"
              fill="#465FFF"
            />
            <path
              opacity="0.6"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.0024 14.0267L25.6691 14.0194C25.673 13.3328 25.6097 12.6578 25.4974 11.9919L27.796 11.5961C27.9338 12.385 28.0069 13.2039 28.0024 14.0267Z"
              fill="#465FFF"
            />
            <path
              opacity="0.65"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M27.7813 16.4585C27.7096 16.8604 27.6207 17.2594 27.5155 17.6495L25.26 17.0398C25.3471 16.7176 25.4238 16.3876 25.4842 16.0488C25.5446 15.7099 25.5878 15.368 25.6175 15.0356L27.9437 15.249C27.9085 15.6457 27.854 16.0507 27.7813 16.4585Z"
              fill="#465FFF"
            />
            <path
              opacity="0.7"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M27.1502 18.8104C26.869 19.5898 26.5182 20.3272 26.1152 21.0256L24.0962 19.8537C24.4308 19.2735 24.7246 18.6563 24.9583 18.0106L27.1502 18.8104Z"
              fill="#465FFF"
            />
            <path
              opacity="0.75"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.4576 22.0518C24.9819 22.7254 24.456 23.3486 23.8809 23.9156L22.2375 22.2655C22.7139 21.7876 23.1561 21.268 23.5461 20.7095L25.4576 22.0518Z"
              fill="#465FFF"
            />
            <path
              opacity="0.8"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.977 24.738C22.3564 25.2614 21.6864 25.7285 20.9798 26.1357L19.8173 24.1152C20.4052 23.7757 20.9612 23.383 21.483 22.9487L22.977 24.738Z"
              fill="#465FFF"
            />
            <path
              opacity="0.95"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.8949 26.7005C19.1583 27.0431 18.3918 27.3212 17.602 27.5299L16.9965 25.2769C17.6565 25.0984 18.2959 24.8688 18.9101 24.5813L19.8949 26.7005Z"
              fill="#465FFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.4064 27.7908C15.6107 27.9333 14.7986 28.0018 13.9747 28.003L13.982 25.6697C14.6697 25.6679 15.3436 25.6103 16.0038 25.497L16.4064 27.7908Z"
              fill="#465FFF"
            />
            <path
              opacity="0.05"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.7496 27.9451C12.3472 27.9089 11.9421 27.8544 11.5401 27.7827C11.1381 27.711 10.7392 27.6221 10.3491 27.5169L10.9531 25.2604C11.281 25.3485 11.611 25.4252 11.9498 25.4856C12.2887 25.546 12.6248 25.5882 12.963 25.6189L12.7496 27.9451Z"
              fill="#465FFF"
            />
            <path
              opacity="0.07"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.98349 24.9569L9.18368 27.1488C8.41105 26.8629 7.67266 26.5179 6.97527 26.1091L8.14613 24.0959C8.72639 24.4305 9.33885 24.7175 9.98349 24.9569Z"
              fill="#465FFF"
            />
            <path
              opacity="0.09"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.28993 23.546L5.94289 25.4507C5.274 24.9818 4.65083 24.4559 4.0781 23.8797L5.73488 22.2317C6.21182 22.7137 6.73242 23.1503 7.28993 23.546Z"
              fill="#465FFF"
            />
            <path
              opacity="0.11"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.04588 21.4804L3.25658 22.9745C2.7343 22.348 2.26717 21.6781 1.86567 20.9725L3.88617 19.81C4.22572 20.3979 4.6116 20.9586 5.04588 21.4804Z"
              fill="#465FFF"
            />
            <path
              opacity="0.13"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.41122 18.9079L1.2988 19.888C0.955126 19.1571 0.677073 18.3906 0.463618 17.5941L2.72132 16.9953C2.89414 17.6543 3.12951 18.2947 3.41122 18.9079Z"
              fill="#465FFF"
            />
            <path
              opacity="0.15"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.5046 16.0023L0.205021 16.404C0.0682692 15.6093 -0.00593473 14.7961 -0.00036207 13.9675L2.33294 13.9749C2.32898 14.6615 2.39126 15.3422 2.5046 16.0023Z"
              fill="#465FFF"
            />
            <path
              opacity="0.17"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.5127 11.9512C2.45227 12.2901 2.41009 12.6262 2.38042 12.9587L0.0532276 12.751C0.089446 12.3486 0.143917 11.9435 0.215615 11.5415C0.287314 11.1395 0.377265 10.7349 0.481372 10.3505L2.73789 10.9545C2.65079 11.2767 2.57313 11.6124 2.5127 11.9512Z"
              fill="#465FFF"
            />
            <path
              opacity="0.19"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.90579 8.14052C3.57018 8.72653 3.27744 9.33796 3.04377 9.98363L0.851821 9.18382C1.13202 8.41017 1.4838 7.66706 1.88584 6.97439L3.90579 8.14052Z"
              fill="#465FFF"
            />
            <path
              opacity="0.21"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.76231 5.73414C5.28701 6.20635 4.84474 6.72593 4.45478 7.28447L2.54328 5.94214C3.01792 5.27427 3.54385 4.6511 4.12003 4.07838L5.76231 5.73414Z"
              fill="#465FFF"
            />
            <path
              opacity="0.25"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.18467 3.8793C7.59675 4.21885 7.04083 4.6115 6.51897 5.04578L5.02494 3.25648C5.64564 2.73317 6.31557 2.26605 7.02222 1.8588L8.18467 3.8793Z"
              fill="#465FFF"
            />
            <path
              opacity="0.28"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.0046 2.71703C10.3447 2.89559 9.70529 3.12522 9.0911 3.41268L8.10522 1.29923C8.84183 0.95658 9.60839 0.678527 10.3992 0.464047L11.0046 2.71703Z"
              fill="#465FFF"
            />
            <path
              opacity="0.3"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.0198 2.3306C13.3331 2.32664 12.6592 2.3842 11.998 2.50329L11.5964 0.203708C12.3911 0.066956 13.2043 -0.0072479 14.0271 -0.00269951L14.0198 2.3306Z"
              fill="#465FFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_3755_26248">
              <rect width="28" height="28" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div className="animate-spin">
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3755_26274)">
            <path
              opacity="0.33"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.6916 0.621317L21.9165 3.51517C21.4948 3.40187 21.0692 3.31072 20.6336 3.23302C20.1979 3.15532 19.7671 3.09371 19.3322 3.05425L19.6053 0.0708458C20.1227 0.117412 20.6435 0.187446 21.1603 0.27963C21.6772 0.371814 22.1901 0.486149 22.6916 0.621317Z"
              fill="#465FFF"
            />
            <path
              opacity="0.38"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M27.0338 2.42422L25.5271 5.01999C24.7823 4.58243 23.9949 4.21343 23.1647 3.913L24.1931 1.09477C25.1878 1.45503 26.1358 1.906 27.0338 2.42422Z"
              fill="#465FFF"
            />
            <path
              opacity="0.42"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M30.7569 5.29752L28.6281 7.40902C28.0149 6.78922 27.3455 6.22797 26.6287 5.71921L28.3607 3.27026C29.2193 3.88052 30.0206 4.55671 30.7569 5.29752Z"
              fill="#465FFF"
            />
            <path
              opacity="0.5"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.6038 9.02768L31.006 10.5223C30.5695 9.76636 30.0734 9.04554 29.515 8.37458L31.8155 6.45368C32.487 7.2591 33.0876 8.12044 33.6038 9.02768Z"
              fill="#465FFF"
            />
            <path
              opacity="0.55"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M35.4023 13.3712L32.4995 14.141C32.2773 13.2938 31.9747 12.4704 31.6112 11.6894L34.3285 10.4218C34.769 11.3689 35.1265 12.3545 35.4023 13.3712Z"
              fill="#465FFF"
            />
            <path
              opacity="0.6"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.0025 18.0344L33.0025 18.025C33.0076 17.1421 32.9262 16.2744 32.7818 15.4182L35.7371 14.9092C35.9143 15.9236 36.0084 16.9765 36.0025 18.0344Z"
              fill="#465FFF"
            />
            <path
              opacity="0.65"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M35.7216 21.1605C35.6294 21.6774 35.5151 22.1903 35.3799 22.6918L32.48 21.9079C32.592 21.4937 32.6905 21.0694 32.7682 20.6338C32.8459 20.1981 32.9015 19.7586 32.9396 19.3311L35.9304 19.6055C35.8851 20.1155 35.8151 20.6363 35.7216 21.1605Z"
              fill="#465FFF"
            />
            <path
              opacity="0.7"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34.9085 24.1849C34.5469 25.187 34.096 26.1351 33.5778 27.033L30.982 25.5263C31.4122 24.7803 31.7899 23.9868 32.0903 23.1566L34.9085 24.1849Z"
              fill="#465FFF"
            />
            <path
              opacity="0.75"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.7306 28.3525C32.1191 29.2185 31.4429 30.0197 30.7034 30.7487L28.5906 28.6273C29.203 28.0128 29.7716 27.3447 30.273 26.6266L32.7306 28.3525Z"
              fill="#465FFF"
            />
            <path
              opacity="0.8"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M29.5419 31.8056C28.7439 32.4785 27.8825 33.0791 26.974 33.6027L25.4794 31.0049C26.2353 30.5683 26.9501 30.0635 27.621 29.5051L29.5419 31.8056Z"
              fill="#465FFF"
            />
            <path
              opacity="0.95"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.5781 34.3294C24.631 34.77 23.6454 35.1275 22.63 35.3958L21.8516 32.4991C22.7001 32.2696 23.5222 31.9743 24.3118 31.6047L25.5781 34.3294Z"
              fill="#465FFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.0923 35.7311C20.0692 35.9143 19.025 36.0023 17.9658 36.0038L17.9752 33.0039C18.8594 33.0016 19.7258 32.9276 20.5746 32.7818L21.0923 35.7311Z"
              fill="#465FFF"
            />
            <path
              opacity="0.05"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.3929 35.9291C15.8755 35.8825 15.3547 35.8125 14.8379 35.7203C14.321 35.6281 13.8081 35.5138 13.3066 35.3786L14.0831 32.4774C14.5047 32.5907 14.929 32.6892 15.3646 32.7669C15.8003 32.8446 16.2325 32.8988 16.6673 32.9383L16.3929 35.9291Z"
              fill="#465FFF"
            />
            <path
              opacity="0.07"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.8348 32.0872L11.8065 34.9054C10.8131 34.5378 9.86373 34.0942 8.96709 33.5686L10.4725 30.9802C11.2185 31.4104 12.006 31.7794 12.8348 32.0872Z"
              fill="#465FFF"
            />
            <path
              opacity="0.09"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.37333 30.2735L7.64142 32.7224C6.78141 32.1195 5.9802 31.4433 5.24383 30.7025L7.37398 28.5837C7.98718 29.2035 8.65653 29.7647 9.37333 30.2735Z"
              fill="#465FFF"
            />
            <path
              opacity="0.11"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.48868 27.618L4.18815 29.5389C3.51664 28.7335 2.91605 27.8722 2.39983 26.9649L4.99763 25.4704C5.43418 26.2263 5.93032 26.9471 6.48868 27.618Z"
              fill="#465FFF"
            />
            <path
              opacity="0.13"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.38753 24.3105L1.67156 25.5707C1.22969 24.631 0.872197 23.6454 0.597754 22.6213L3.50051 21.8516C3.72271 22.6988 4.02533 23.5222 4.38753 24.3105Z"
              fill="#465FFF"
            />
            <path
              opacity="0.15"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.21965 20.5744L0.263041 21.0907C0.0872167 20.069 -0.00818841 19.0235 -0.00102356 17.9582L2.99893 17.9676C2.99384 18.8504 3.07392 19.7256 3.21965 20.5744Z"
              fill="#465FFF"
            />
            <path
              opacity="0.17"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.23284 15.3663C3.15514 15.8019 3.10091 16.2341 3.06277 16.6616L0.0706677 16.3945C0.117234 15.8772 0.187268 15.3564 0.279452 14.8395C0.371636 14.3227 0.487288 13.8024 0.621139 13.3082L3.52237 14.0847C3.41039 14.499 3.31054 14.9307 3.23284 15.3663Z"
              fill="#465FFF"
            />
            <path
              opacity="0.19"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.0195 10.4667C4.588 11.2202 4.21162 12.0063 3.91119 12.8364L1.09297 11.8081C1.45322 10.8134 1.90551 9.858 2.42242 8.96742L5.0195 10.4667Z"
              fill="#465FFF"
            />
            <path
              opacity="0.21"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.40813 7.37267C6.79703 7.9798 6.2284 8.64783 5.72701 9.36595L3.26937 7.6401C3.87963 6.78142 4.55582 5.9802 5.29662 5.24384L7.40813 7.37267Z"
              fill="#465FFF"
            />
            <path
              opacity="0.25"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.5243 4.98775C9.76837 5.4243 9.05362 5.92914 8.38265 6.4875L6.46176 4.18697C7.25979 3.51415 8.12113 2.91356 9.02969 2.38996L10.5243 4.98775Z"
              fill="#465FFF"
            />
            <path
              opacity="0.28"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.1505 3.49354C13.302 3.72312 12.4799 4.01835 11.6902 4.38794L10.4227 1.67065C11.3697 1.2301 12.3553 0.872601 13.372 0.596841L14.1505 3.49354Z"
              fill="#465FFF"
            />
            <path
              opacity="0.3"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.0243 2.99635C17.1415 2.99125 16.275 3.06526 15.4249 3.21838L14.9086 0.261771C15.9303 0.0859468 16.9758 -0.00945823 18.0337 -0.00361029L18.0243 2.99635Z"
              fill="#465FFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_3755_26274">
              <rect width="36" height="36" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div className="animate-spin">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3755_26300)">
            <path
              opacity="0.33"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.2129 0.690352L24.3516 3.90574C23.8831 3.77985 23.4102 3.67858 22.9262 3.59225C22.4422 3.50591 21.9634 3.43745 21.4803 3.39361L21.7837 0.0787176C22.3586 0.130458 22.9372 0.208273 23.5115 0.3107C24.0858 0.413127 24.6556 0.540165 25.2129 0.690352Z"
              fill="#465FFF"
            />
            <path
              opacity="0.38"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M30.0349 2.69336L28.3608 5.57755C27.5333 5.09137 26.6584 4.68137 25.736 4.34756L26.8786 1.2162C27.9838 1.61648 29.0372 2.11756 30.0349 2.69336Z"
              fill="#465FFF"
            />
            <path
              opacity="0.42"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34.1744 5.88602L31.809 8.23214C31.1277 7.54347 30.3839 6.91986 29.5875 6.35456L31.5118 3.63352C32.4659 4.31158 33.3562 5.0629 34.1744 5.88602Z"
              fill="#465FFF"
            />
            <path
              opacity="0.5"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M37.3376 10.031L34.4512 11.6916C33.9661 10.8517 33.4148 10.0508 32.7944 9.3053L35.3506 7.17097C36.0967 8.06589 36.764 9.02293 37.3376 10.031Z"
              fill="#465FFF"
            />
            <path
              opacity="0.55"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M39.3367 14.8571L36.1114 15.7124C35.8645 14.7711 35.5283 13.8562 35.1244 12.9885L38.1436 11.58C38.6331 12.6323 39.0303 13.7274 39.3367 14.8571Z"
              fill="#465FFF"
            />
            <path
              opacity="0.6"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M40.0045 20.0382L36.6712 20.0277C36.6769 19.0468 36.5865 18.0826 36.426 17.1314L39.7097 16.5658C39.9065 17.6929 40.011 18.8627 40.0045 20.0382Z"
              fill="#465FFF"
            />
            <path
              opacity="0.65"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M39.6898 23.5118C39.5874 24.0861 39.4603 24.656 39.3101 25.2132L36.088 24.3423C36.2124 23.882 36.3219 23.4105 36.4083 22.9265C36.4946 22.4425 36.5563 21.9541 36.5987 21.4791L39.9218 21.784C39.8715 22.3507 39.7937 22.9293 39.6898 23.5118Z"
              fill="#465FFF"
            />
            <path
              opacity="0.7"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M38.7838 26.8719C38.382 27.9854 37.8809 29.0387 37.3051 30.0365L34.421 28.3624C34.8989 27.5334 35.3186 26.6517 35.6524 25.7293L38.7838 26.8719Z"
              fill="#465FFF"
            />
            <path
              opacity="0.75"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.3691 31.5028C35.6896 32.4651 34.9383 33.3553 34.1166 34.1653L31.769 31.8081C32.4495 31.1253 33.0813 30.3831 33.6384 29.5852L36.3691 31.5028Z"
              fill="#465FFF"
            />
            <path
              opacity="0.8"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.8204 35.3399C31.9337 36.0875 30.9767 36.7548 29.9672 37.3366L28.3065 34.4502C29.1464 33.9651 29.9406 33.4042 30.6861 32.7838L32.8204 35.3399Z"
              fill="#465FFF"
            />
            <path
              opacity="0.95"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.4197 38.1436C27.3674 38.6331 26.2723 39.0303 25.1441 39.3285L24.2791 36.11C25.2219 35.8549 26.1353 35.5269 27.0127 35.1162L28.4197 38.1436Z"
              fill="#465FFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.4372 39.7012C22.3004 39.9047 21.1402 40.0025 19.9633 40.0043L19.9738 36.671C20.9562 36.6684 21.9189 36.5862 22.862 36.4243L23.4372 39.7012Z"
              fill="#465FFF"
            />
            <path
              opacity="0.05"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.2165 39.9211C17.6416 39.8694 17.063 39.7916 16.4887 39.6891C15.9144 39.5867 15.3445 39.4597 14.7873 39.3095L15.65 36.0859C16.1185 36.2118 16.59 36.3213 17.074 36.4076C17.558 36.4939 18.0382 36.5542 18.5214 36.598L18.2165 39.9211Z"
              fill="#465FFF"
            />
            <path
              opacity="0.07"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.2644 35.6526L13.1218 38.784C12.018 38.3755 10.9632 37.8826 9.96691 37.2986L11.6396 34.4226C12.4685 34.9006 13.3434 35.3106 14.2644 35.6526Z"
              fill="#465FFF"
            />
            <path
              opacity="0.09"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.4131 33.637L8.48873 36.358C7.53317 35.6882 6.64293 34.9368 5.82474 34.1137L8.19158 31.7594C8.87291 32.4481 9.61663 33.0717 10.4131 33.637Z"
              fill="#465FFF"
            />
            <path
              opacity="0.11"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.21008 30.6866L4.65394 32.8209C3.90781 31.926 3.24049 30.969 2.66692 29.9609L5.55335 28.3003C6.03841 29.1402 6.58968 29.9411 7.21008 30.6866Z"
              fill="#465FFF"
            />
            <path
              opacity="0.13"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.87373 27.0114L1.85599 28.4116C1.36502 27.3675 0.967806 26.2724 0.662869 25.1345L3.88816 24.2792C4.13504 25.2205 4.47128 26.1354 4.87373 27.0114Z"
              fill="#465FFF"
            />
            <path
              opacity="0.15"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.57521 22.8606L0.290098 23.4344C0.0947373 22.2991 -0.0112684 21.1374 -0.00330742 19.9538L3.32998 19.9642C3.32432 20.9451 3.41329 21.9175 3.57521 22.8606Z"
              fill="#465FFF"
            />
            <path
              opacity="0.17"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.59292 17.0733C3.50658 17.5574 3.44633 18.0376 3.40394 18.5125L0.0793877 18.2158C0.131128 17.641 0.208943 17.0623 0.31137 16.488C0.413797 15.9138 0.542299 15.3357 0.691022 14.7866L3.91461 15.6494C3.79019 16.1097 3.67925 16.5893 3.59292 17.0733Z"
              fill="#465FFF"
            />
            <path
              opacity="0.19"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.58026 11.6296C5.10082 12.4668 4.68262 13.3402 4.3488 14.2626L1.21744 13.12C1.61773 12.0148 2.12027 10.9532 2.69461 9.96369L5.58026 11.6296Z"
              fill="#465FFF"
            />
            <path
              opacity="0.21"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.23299 8.19169C7.55399 8.86628 6.92218 9.60854 6.36508 10.4065L3.63437 8.48884C4.31243 7.53475 5.06376 6.6445 5.88687 5.82632L8.23299 8.19169Z"
              fill="#465FFF"
            />
            <path
              opacity="0.25"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.6941 5.54172C10.8542 6.02679 10.06 6.58772 9.31449 7.20812L7.18016 4.65198C8.06687 3.90439 9.02392 3.23707 10.0334 2.65529L11.6941 5.54172Z"
              fill="#465FFF"
            />
            <path
              opacity="0.28"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.7215 3.88154C14.7787 4.13663 13.8653 4.46467 12.9878 4.87532L11.5794 1.85611C12.6317 1.36661 13.7268 0.969394 14.8565 0.662994L15.7215 3.88154Z"
              fill="#465FFF"
            />
            <path
              opacity="0.3"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.0266 3.32922C19.0457 3.32356 18.0829 3.40579 17.1384 3.57592L16.5646 0.290803C17.6999 0.0954421 18.8616 -0.0105634 20.037 -0.0040657L20.0266 3.32922Z"
              fill="#465FFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_3755_26300">
              <rect width="40" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div className="animate-spin">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3755_26326)">
            <path
              opacity="0.33"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M30.2555 0.828423L29.2219 4.68689C28.6597 4.53582 28.0923 4.41429 27.5114 4.31069C26.9306 4.2071 26.3561 4.12494 25.7763 4.07233L26.1404 0.0944611C26.8303 0.15655 27.5247 0.249928 28.2138 0.37284C28.9029 0.495752 29.5868 0.648198 30.2555 0.828423Z"
              fill="#465FFF"
            />
            <path
              opacity="0.38"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.045 3.23213L34.0361 6.69316C33.0431 6.10974 31.9932 5.61774 30.8863 5.21717L32.2574 1.45954C33.5837 1.93988 34.8477 2.54117 36.045 3.23213Z"
              fill="#465FFF"
            />
            <path
              opacity="0.42"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M41.0092 7.06352L38.1708 9.87886C37.3532 9.05246 36.4607 8.30413 35.505 7.62577L37.8142 4.36051C38.9591 5.17419 40.0274 6.07578 41.0092 7.06352Z"
              fill="#465FFF"
            />
            <path
              opacity="0.5"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M44.8051 12.0371L41.3414 14.0298C40.7593 13.022 40.0978 12.0609 39.3533 11.1663L42.4207 8.60507C43.316 9.67897 44.1168 10.8274 44.8051 12.0371Z"
              fill="#465FFF"
            />
            <path
              opacity="0.55"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M47.2056 17.8284L43.3353 18.8548C43.039 17.7252 42.6355 16.6273 42.1508 15.586L45.7739 13.896C46.3613 15.1587 46.8379 16.4728 47.2056 17.8284Z"
              fill="#465FFF"
            />
            <path
              opacity="0.6"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M48.0046 24.0458L44.0047 24.0333C44.0115 22.8562 43.903 21.6992 43.7104 20.5576L47.6508 19.879C47.887 21.2314 48.0124 22.6353 48.0046 24.0458Z"
              fill="#465FFF"
            />
            <path
              opacity="0.65"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M47.6262 28.2144C47.5033 28.9035 47.3508 29.5873 47.1706 30.2561L43.3041 29.2109C43.4534 28.6586 43.5847 28.0928 43.6883 27.512C43.7919 26.9312 43.866 26.3451 43.9169 25.7751L47.9046 26.141C47.8442 26.821 47.7509 27.5154 47.6262 28.2144Z"
              fill="#465FFF"
            />
            <path
              opacity="0.7"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M46.5421 32.2464C46.06 33.5825 45.4587 34.8466 44.7677 36.0439L41.3067 34.0349C41.8803 33.0402 42.3839 31.9822 42.7845 30.8753L46.5421 32.2464Z"
              fill="#465FFF"
            />
            <path
              opacity="0.75"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M43.6422 37.8034C42.8267 38.9582 41.9252 40.0265 40.9392 40.9985L38.1221 38.1699C38.9386 37.3505 39.6968 36.4598 40.3653 35.5023L43.6422 37.8034Z"
              fill="#465FFF"
            />
            <path
              opacity="0.8"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M39.3853 42.4075C38.3213 43.3046 37.1728 44.1054 35.9614 44.8036L33.9686 41.3398C34.9765 40.7578 35.9295 40.0846 36.8241 39.3402L39.3853 42.4075Z"
              fill="#465FFF"
            />
            <path
              opacity="0.95"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34.1028 45.7725C32.8401 46.3599 31.5259 46.8366 30.1721 47.1944L29.1341 43.3322C30.2655 43.0261 31.3616 42.6324 32.4145 42.1397L34.1028 45.7725Z"
              fill="#465FFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.1231 47.6414C26.759 47.8857 25.3667 48.0031 23.9544 48.0051L23.967 44.0052C25.1458 44.0021 26.3011 43.9034 27.4328 43.7091L28.1231 47.6414Z"
              fill="#465FFF"
            />
            <path
              opacity="0.05"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.8598 47.9056C21.17 47.8435 20.4756 47.7502 19.7864 47.6272C19.0973 47.5043 18.4135 47.3519 17.7447 47.1717L18.78 43.3034C19.3422 43.4544 19.908 43.5858 20.4888 43.6894C21.0696 43.793 21.6459 43.8653 22.2257 43.9179L21.8598 47.9056Z"
              fill="#465FFF"
            />
            <path
              opacity="0.07"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.1157 42.783L15.7446 46.5406C14.4201 46.0504 13.1542 45.459 11.9587 44.7581L13.9659 41.307C14.9606 41.8805 16.0106 42.3725 17.1157 42.783Z"
              fill="#465FFF"
            />
            <path
              opacity="0.09"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.4965 40.3645L10.1873 43.6297C9.04058 42.8259 7.97229 41.9243 6.99047 40.9366L9.83067 38.1114C10.6483 38.9378 11.5407 39.6861 12.4965 40.3645Z"
              fill="#465FFF"
            />
            <path
              opacity="0.11"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.64897 36.8237L5.5816 39.3849C4.68625 38.311 3.88547 37.1626 3.19717 35.9529L6.6609 33.9602C7.24297 34.968 7.90449 35.9291 8.64897 36.8237Z"
              fill="#465FFF"
            />
            <path
              opacity="0.13"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.85004 32.414L2.22875 34.0943C1.63959 32.8414 1.16293 31.5273 0.797005 30.1618L4.66735 29.1354C4.96362 30.265 5.3671 31.3629 5.85004 32.414Z"
              fill="#465FFF"
            />
            <path
              opacity="0.15"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.29026 27.4326L0.348117 28.1211C0.113685 26.7588 -0.0135221 25.3648 -0.00396891 23.9444L3.99597 23.957C3.98918 25.1341 4.09595 26.3009 4.29026 27.4326Z"
              fill="#465FFF"
            />
            <path
              opacity="0.17"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.30916 20.4884C4.20556 21.0692 4.13325 21.6455 4.08239 22.2154L0.0929215 21.8594C0.15501 21.1696 0.248388 20.4752 0.371301 19.786C0.494213 19.0969 0.648415 18.4032 0.826883 17.7443L4.69519 18.7796C4.54588 19.332 4.41275 19.9076 4.30916 20.4884Z"
              fill="#465FFF"
            />
            <path
              opacity="0.19"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.69397 13.9553C6.11864 14.9599 5.6168 16.0081 5.21622 17.1149L1.45859 15.7438C1.93893 14.4176 2.54198 13.1437 3.23119 11.9562L6.69397 13.9553Z"
              fill="#465FFF"
            />
            <path
              opacity="0.21"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.87881 9.83023C9.06401 10.6397 8.30583 11.5304 7.63732 12.4879L4.36046 10.1868C5.17414 9.04189 6.07573 7.9736 7.06347 6.99178L9.87881 9.83023Z"
              fill="#465FFF"
            />
            <path
              opacity="0.25"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.0298 6.65017C13.0219 7.23224 12.0689 7.90536 11.1743 8.64984L8.61307 5.58247C9.67712 4.68537 10.8256 3.88458 12.037 3.18644L14.0298 6.65017Z"
              fill="#465FFF"
            />
            <path
              opacity="0.28"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.8673 4.65805C17.736 4.96415 16.6399 5.3578 15.587 5.85058L13.8969 2.22753C15.1596 1.64013 16.4738 1.16347 17.8294 0.795788L18.8673 4.65805Z"
              fill="#465FFF"
            />
            <path
              opacity="0.3"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24.035 3.99497C22.8579 3.98818 21.7026 4.08686 20.5692 4.291L19.8807 0.348865C21.243 0.114433 22.637 -0.0127737 24.0475 -0.00497648L24.035 3.99497Z"
              fill="#465FFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_3755_26326">
              <rect width="48" height="48" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
}
